<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <img src="@/assets/images/icon-logo.png" style="width:36px;height:36px;margin-top:16px;">
<!--                  <p class="p1">学生管理与服务一体化平台</p>-->
<!--        <img v-if="logo" :src="logo" class="sidebar-logo" />-->
<!--          <p class="p1">用电分析预测平台</p>-->
<!--        <p class="p2"> Electricity demand analysis and prediction platform</p>-->
<!--        <h1 v-else class="sidebar-title" :style="{ color: sideTheme === 'theme-dark' ? variables.logoTitleColor : variables.logoLightTitleColor }">{{ title }} </h1>-->
      </router-link>
      <router-link v-else key="expand" class="top-content" to="/">
          <img src="@/assets/images/icon-logo.png" style="width:48px;height:48px;">
          <p class="p1 commonTextColor">AI食育师</p>
<!--          <p class="p2"> Electricity demand analysis and prediction platform</p>-->
<!--        <img v-if="logo" :src="logo" class="sidebar-logo" />-->
<!--        <h1 class="sidebar-title" :style="{ color: sideTheme === 'theme-dark' ? variables.logoTitleColor : variables.logoLightTitleColor }">  {{ title }} </h1>-->
      </router-link>
    </transition>
  </div>
</template>

<script>
import variables from '@/assets/styles/variables.scss'
import {mapState} from "vuex";

export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapState(["settings"]),
    variables() {
      return variables;
    },
    sideTheme() {
      return this.$store.state.settings.sideTheme
    }
  },
  data() {
    return {
      title: process.env.VUE_APP_TITLE,
      // logo: logoImg
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  /*line-height: 50px;*/
  background: #FFF;
  text-align: center;
  overflow: hidden;
  .top-content{
    text-align: center;
    padding:10px 0 16px 0;
    img{
      width:60px;
      height:60px;
    }
    p{
      line-height: 1;
      margin-top:10px;
    }
    .p1{
      font-size:18px;
      font-weight:bold;
    }
    .p2{
      font-size:10px;
      padding:0 20px;
      line-height:1.5;
    }
  }
  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 30px;
      height: 30px;
      vertical-align: middle;
      margin-left: -6px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
